import { ChangeEvent, useEffect, useState } from 'react'
import { Typography, useMediaQuery, useTheme, Link } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SearchBar } from '../search-bar'
import { AccountManualButton } from './account-manual-button.component'
import { IAssociationModalProps } from '.'
import { useAllAccountsRaw } from 'src/hooks'

import useStyles from './styles'
import { AssociationsListItem, AssociationsListWrapper } from '../associations-list'
import { HelperWrapper } from '../helper-wrapper'
import { ETranslationNs } from 'src/types'

interface IProps extends IAssociationModalProps {
  handleClose: () => void
}

const AccountsModal = ({
  selectedItems = [],
  handleSelectItem = () => {},
  isImageRound,
  handleClose,
}: IProps) => {
  const [t] = useTranslation(ETranslationNs.Form)
  const [search, setSearch] = useState('')
  const { data: accouns, refetch: refetchAccounts } = useAllAccountsRaw({
    query: search,
    columns: ['website', 'address', 'ai_generated'],
  })
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const classes = useStyles({ isRound: isImageRound, fullWidth: true })

  useEffect(() => {
    refetchAccounts()
  }, [search, refetchAccounts])

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    setSearch(query)
  }

  const handleItemClick = (id: string) => () => {
    handleSelectItem(id)
  }

  return (
    <>
      {!isTablet && (
        <Typography className={classes.paperTitle}>
          <HelperWrapper t="accounts-association-modal-title" ns={ETranslationNs.Form} />
        </Typography>
      )}
      <SearchBar
        handleSearchChange={handleSearchChange}
        search={search}
        inputPlaceholder={t('accounts-association-search.v')}
      />

      <div className={classes.listWrapper}>
        <AssociationsListWrapper>
          {accouns?.data
            .sort((a, b) => {
              const aIsActive = selectedItems?.some((itemId) => itemId === a.id)
              const bIsActive = selectedItems?.some((itemId) => itemId === b.id)
              if (aIsActive && !bIsActive) {
                return -1
              }
              if (bIsActive && !aIsActive) {
                return 1
              }
              return 0
            })
            .map((props) => {
              return (
                <AssociationsListItem
                  key={props.id}
                  active={selectedItems?.some((itemId) => itemId === props.id)}
                  handleClick={handleItemClick(props.id)}
                  image={props.image_small || props.image}
                  title={props.account_holder}
                  subtitle={props.address}
                  aiGenerated={props.ai_generated}
                  additionalInfo={
                    <>
                      {props.website && (
                        <Link
                          href={props.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={classes.boxSubtext}
                        >
                          {props.website}
                        </Link>
                      )}
                    </>
                  }
                />
              )
            })}
          {accouns?.data.length === 0 && (
            <Typography className={classes.boxInfoText}>
              <HelperWrapper t="accounts-association-modal-not-found" ns={ETranslationNs.Form} />
            </Typography>
          )}
        </AssociationsListWrapper>
      </div>
      <AccountManualButton handleAccountsClose={handleClose} />
    </>
  )
}

export { AccountsModal }
